import React from 'react';

export default function ProjectWebsite(props?: SVGProps) {
	return (
		<svg viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M7.87786 6.23018C6.92018 5.13657 4.9403 4.92724 3.70011 6.01328L2.94792 6.67197C1.70159 7.76339 1.55099 9.63058 2.61166 10.8418C3.52553 11.8854 5.04073 12.1016 6.23977 11.4431C6.43627 11.3351 6.62044 11.2061 6.78903 11.0583'
				className='theme-stroke'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6.1224 7.76759C7.0797 8.86077 9.05958 9.0701 10.2998 7.98406L11.052 7.32537C12.2983 6.23395 12.4493 4.36719 11.3886 3.15596C10.4744 2.11194 8.95877 1.89535 7.76012 2.55422C7.56363 2.66222 7.37946 2.79125 7.21086 2.93906'
				className='theme-stroke'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}
